import React from "react";
import { useTranslation } from "react-i18next";
import {
	formatAmount,
	formatForeignPaymentSummary,
} from "../utils/patientAccountUtils";

const PatientAccountPaidAmount = ({
	amount,
	currency,
	foreignPayments = [],
	getCurrencySymbol,
	className = "",
}) => {
	const { t } = useTranslation();
	const foreignLabel = formatForeignPaymentSummary(foreignPayments, getCurrencySymbol);

	return (
		<div className={`pa-paid-amount-cell ${className}`.trim()}>
			<span className="pa-paid-amount-primary">
				{formatAmount(amount, currency, getCurrencySymbol)}
			</span>
			{foreignLabel && (
				<small className="pa-foreign-payment-hint">
					{t("Collected")}: {foreignLabel}
				</small>
			)}
		</div>
	);
};

export default PatientAccountPaidAmount;
